import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environmentService } from "./environmentsService.Service";
import { HelpCenterItemModel } from "../models/HelpCenterModels/HelpCenterItemModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";


@Injectable({
  providedIn: 'root'
})
export class HelpCenterService {
  ApiUrl = "/api/admin/HelpCenter/"

  constructor(private http: RequestHandlerService) { }

  AddHelpCenter( AddModel: HelpCenterItemModel) {
    
    return this.http.post(this.ApiUrl + 'AddHelpCenterItem', AddModel);
  }
  EditHelpCenter(EditModel: HelpCenterItemModel) {
    
    return this.http.post(this.ApiUrl + 'EditHelpCenter', EditModel);
  }
  DeleteHelpCenter( id: string) {
   
    let params = new HttpParams();
    params = params.append("id",id);
    return this.http.post( this.ApiUrl + 'DeleteHelpCenter', null,params);
  }

  Loaddropdowns() {
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  GetHelpCenterLevel( ParentId: string) {

    let params = new HttpParams();
    params = params.append("parentID", ParentId);
    return this.http.post(this.ApiUrl + 'GetHelpCenterItemsByFilter', null, params);
  }

  GenerateCode() {
    
    return this.http.get( this.ApiUrl + 'GenerateCode');
  }
  GetAll() {
    return this.http.get( this.ApiUrl + 'Preview', null);
  }
}

